webpackJsonp([1],{

/***/ "+HEJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAtUlEQVRYR+2W0Q3CMAxELxuxQbsBbEBHuE1yI5QN6AZ0AzYCuQLUUH7rRMKW8ps7vfgcJ1SuVFkfYSAIfAiQPAA4OjXlJOluWmsDNwCdk4FZUv9tYABgx6NGSWNhwEP1l0akIAgUBEj2KaXH3g2Zc57fGus5YLE47y3+uv8iaYl8OwbMjT2BBwFJNnWXihQEgXYIkLRces6B8jsmWX0hsZXs5DEHAFw3K5mT8EamnSYMAn9L4AkhrTEhoED4xwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "+NVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    goSaves: function goSaves() {
      this.$emit('showSave');
    },
    emitSet: function emitSet() {
      this.$emit('setting');
    }
  }
});

/***/ }),

/***/ "+eK2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0i8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['article1', 'night']
});

/***/ }),

/***/ "1Tvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function set (name, val) {
  var json = JSON.stringify(val)
  return localStorage.setItem(name, json)
}
function get (name) {
  var data = localStorage.getItem(name)
  return JSON.parse(data)
}

/* harmony default export */ __webpack_exports__["a"] = ({
	set: set,
	get: get
});


/***/ }),

/***/ "97eQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fontSize: [{ content: '小', val: '0.3rem' }, { content: '中', val: '0.35rem' }, { content: '大', val: '0.4rem' }],
      bg: ['#fafafa', 'rgb(207, 249, 235)', 'rgb(241,229,201)', 'rgb(253, 214, 246)'],
      defaultSize: 1,
      defaultBg: 0,
      night: false
    };
  },

  methods: {
    setSize: function setSize(index) {
      this.defaultSize = index;
      this.$emit('setSize', this.fontSize[index].val);
    },
    setBg: function setBg(index) {
      this.defaultBg = index;
      this.night = false;
      // this.$emit('setNight')
      this.$emit('setBg', this.bg[index]);
    },
    setNight: function setNight() {
      this.night = !this.night;
      this.$emit('setNight');
    }
  }
});

/***/ }),

/***/ "9Vad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "leftMenu",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ul', {
    staticClass: "leftMenu_c"
  }, [_c('li', {
    on: {
      "click": _vm.goSaves
    }
  }, [_vm._v("我的收藏")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.emitSet
    }
  }, [_vm._v("阅读设置")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_vm._v("给个好评")]), _vm._v(" "), _c('hr')])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AkOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_rightMenu_vue__ = __webpack_require__("zH1Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_e71029ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_rightMenu_vue__ = __webpack_require__("Itdh");
function injectStyle (ssrContext) {
  __webpack_require__("R5d3")
}
var normalizeComponent = __webpack_require__("J0+h")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e71029ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_rightMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_e71029ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_rightMenu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DXbv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._g({
    class: {
      marL: _vm.leftmenu, Inight: _vm.night
    },
    style: ({
      'background-color': _vm.Ibg
    }),
    attrs: {
      "id": "app"
    }
  }, {
    click: _vm.hideMenu,
    touchstart: _vm.ts,
    touchmove: _vm.tm,
    touchend: _vm.te
  }), [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("+HEJ")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.leftMenus($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__("T325")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.rightMenus($event)
      }
    }
  })]), _vm._v(" "), _c('leftMenu', _vm._g({
    class: {
      L: _vm.leftmenu
    }
  }, {
    setting: _vm.Setting,
    showSave: _vm.showSave
  })), _vm._v(" "), _c('rightMenu', _vm._g({
    class: {
      R: _vm.rightmenu
    },
    attrs: {
      "article": _vm.article,
      "save": _vm.isSaved
    }
  }, {
    hidee: _vm.hideRight,
    Save: _vm.Save,
    removeSave: _vm.removeSave,
    article: _vm.NPArticle,
    random: _vm.randomArticle,
    today: _vm.getArticle
  })), _vm._v(" "), _c('router-view', {
    attrs: {
      "article1": _vm.article,
      "night": _vm.night
    }
  }), _vm._v(" "), _c('setting', _vm._g({
    class: {
      hideSetting: _vm.setting
    }
  }, {
    setSize: _vm.setSize,
    setNight: _vm.setNight,
    setBg: _vm.setBg
  })), _vm._v(" "), _c('saveArticle', _vm._g({
    class: {
      showSave: _vm.showS
    },
    attrs: {
      "saveArticles": _vm.saveTotal
    }
  }, {
    hide: _vm.showSave,
    go: _vm.NPArticle
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sc"
    }
  }, [(_vm.isSC) ? _c('span', {
    staticClass: "SC"
  }, [_vm._v(_vm._s(_vm.issc ? '收藏成功' : '取消收藏'))]) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HwfQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IkKL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Itdh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "on rightMenu",
    on: {
      "click": _vm.hideRight
    }
  }, [_c('ul', {
    staticClass: "rightMenu_c on",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('li', {
    on: {
      "click": _vm.Save
    }
  }, [(_vm.saved) ? _c('img', {
    attrs: {
      "src": __webpack_require__("TIua"),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": __webpack_require__("iFoD"),
      "alt": ""
    }
  }), _vm._v("\n          收藏\n        ")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.goPrev
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("nNSp"),
      "alt": ""
    }
  }), _vm._v("\n          前一天\n        ")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.goRandom
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("uRnU"),
      "alt": ""
    }
  }), _vm._v("\n          随机\n        ")]), _vm._v(" "), (_vm.isToday) ? _c('div', [_c('li', {
    on: {
      "click": _vm.goNext
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("liws"),
      "alt": ""
    }
  }), _vm._v("\n            后一天\n          ")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.getToday
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("OEmr"),
      "alt": ""
    }
  }), _vm._v("\n            今日\n          ")])]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JGBW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ul', {
    staticClass: "setting_c"
  }, [_c('li', {
    staticClass: "fontSize"
  }, [_c('span', [_vm._v("字号")]), _vm._v(" "), _c('div', _vm._l((_vm.fontSize), function(size, index) {
    return _c('span', {
      key: size.content,
      class: {
        on: index == _vm.defaultSize
      },
      on: {
        "click": function($event) {
          _vm.setSize(index)
        }
      }
    }, [_vm._v(_vm._s(size.content))])
  }))]), _vm._v(" "), _c('li', {
    staticClass: "bg"
  }, [_c('span', [_vm._v("背景")]), _vm._v(" "), _c('div', _vm._l((_vm.bg), function(bgc, index) {
    return _c('span', {
      key: bgc,
      style: ({
        'background-color': bgc
      }),
      on: {
        "click": function($event) {
          _vm.setBg(index)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.defaultBg),
        expression: "index == defaultBg"
      }]
    }, [_vm._v("√")])])
  }))]), _vm._v(" "), _c('li', {
    staticClass: "night"
  }, [_c('span', [_vm._v("夜间")]), _vm._v(" "), _c('div', {
    class: {
      on: _vm.night
    },
    on: {
      "click": _vm.setNight
    }
  }, [_vm._v("\n          开关\n        ")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K39l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saveArticle"
  }, [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("P9/e")
    },
    on: {
      "click": _vm.hideCur
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saveArticle_c"
  }, [_c('ul', _vm._l((_vm.saveArticles), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.goArticle(item.date)
        }
      }
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "author"
    }, [_vm._v(_vm._s(item.author))])])
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("h8+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_60ac0b50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("DXbv");
function injectStyle (ssrContext) {
  __webpack_require__("IkKL")
}
var normalizeComponent = __webpack_require__("J0+h")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_60ac0b50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("UFcW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("BMa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_utils__ = __webpack_require__("xffy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Store__ = __webpack_require__("RvTR");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__Store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OEmr":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAC7UlEQVRYR8VX23UaMRAdSQWEDmJXEOuM/oMrCKnApoKQCkI6wBUYKrBTQfC/dNZUENwBKWClnNmM9ohlH1r4sH58vIw0V3fuPCTgnZd4Z/8wCkBRFDfe+7sQwg0ATIQQ9BdCCK8AcBBCvEopN1pr+j9rZQFwzt0DwA8AuMo6FWAfQlgaYzZD9r0A6MZlWT7GmyaHvcF/Jwf6JoSYMLiPqUNiRik172OkE4C1diaEeCSq46EhhI1SatV1IANeCCHuEiCHEMLcGPPcxkYrAHb+lGx4kVLea633Q5TS70VRXHnv1wDwOdpLKW+11tvm/hMALLTf8eZ0a2MMaeBkEVCl1KHtYDK21q4TNg4M4kigJwCcc2TwidXd6Zx+d84FAHhBxGkXMykI0oQxRqe2RwBY7RR3Wr0H5wJgO6I+hmOOiBSeajUBUIwrJUspr4dinsNAook/7HOPiNcnADj2RQ71cXMugKYepJQ6ZlLNgHNuBQDf+Pa1QZ/qxwBILwgAD4i4OAqBcy7G6Q0RsyreGADMApXrD6m+Ugai+gfFd04IUjGm2ZACoJSixvLLGDPro74BYC+l/JrTgKy1z0KIL7QfESvfFwFoFJqVlPKn1rrqD21rCMDoEHCKTbnsUvpS3V90dcFEZztErFp5ykAU4VGe5oSiKIqJ955UTS2bwrhVSn1vhsVa2yvC0WnYBMepRudUVS/N98E0PKcQdbHjnCM2Joi4jDapXloLEafJqFKcE56WUnxUZzqbEcXRGHOb62SgYuY1I2ahbscAsEbE+SUgGqlaqz+e2TqQlGW55ZJJdmeDaMwCf5VS02ZmZI1knFY0XGaPZDzM1oNK9kiWqJbKMY1U1DziWkspH/qGUu89ddR6hAsh0M1nXWPb4FjOVa4a0ZJFFa96jPC3+EipJ2j+vuNhtvOhMuZhQjl9NPf3iJPeDct09OqyzQIQN3OxInqrp1kcXgFgx2zQ02yd0xk7s+CSlDtn7ygGznEwtOcf4vPUMLIrRJQAAAAASUVORK5CYII="

/***/ }),

/***/ "Oj91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_leftMenu_vue__ = __webpack_require__("+NVM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_273ac036_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_leftMenu_vue__ = __webpack_require__("9Vad");
function injectStyle (ssrContext) {
  __webpack_require__("omiU")
}
var normalizeComponent = __webpack_require__("J0+h")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-273ac036"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_leftMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_273ac036_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_leftMenu_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P9/e":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABC0lEQVRYR+2W0Q3CIBBAORhAR7G5DlA30Q10FDfQSdQJ2lF0gBaDqQlBKnDl2pi0f3zcvdfjjhyImT+YmS8Wgf+uQF3XG9NDRVE01F4iV8DAu667GrCUckuVIAlY8HX/5ydEPFCqkCzgwrXWl7IsdxS4iUkSyA1PEuCARwtwwaMEOOFBAW74TwEPvJFSkkbtDQJ4+t4K7xR45pw6ZXbcHRErN9GgQNu2NwBY5SD3OeIFTICpgi2htW6UUscRQo/oK/hAXAkhxBkR9yMkvkKDLyG3RFDAdx05KxElwCkRLcAlkSTAIZEsMCAx3ULijqg5K6WqSVcyW2K2pTTXY0TqgVzw4D6QEzSUa6nAC/szxCH90VEuAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Punr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    class: {
      c_night: _vm.night
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article1.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.article1.author))]), _vm._v(" "), _c('div', {
    staticClass: "content_c",
    domProps: {
      "innerHTML": _vm._s(_vm.article1.content)
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('footer', [_vm._v("\n      全文完  共" + _vm._s(_vm.article1.wc) + "字\n    ")])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5d3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RvTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("UFcW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("Gwb+");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: {
    articleSave: false,
    aa: 'aa'
  },
  getters: {
    toUp: function toUp(state) {
      return state.aa.toUpperCase();
    }
  },
  mutations: {
    changeSave: function changeSave(state, xx) {
      state.articleSave += xx.xx;
    }
  },
  actions: {
    changeSave: function changeSave(_ref) {
      var commit = _ref.commit;

      commit('changeSave');
    }
  }
}));

/***/ }),

/***/ "T325":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAgCAYAAAB3j6rJAAAA50lEQVRYR+1VwQ3CMAy8TEBH6AYwAkwAGwAbeASYIMcEtBNQNoAJYCRkKUVRSoh4gIpkP+vT9Xw+Kw4jKTcSHTAh6SbMEXOkdJ2WEcvIf2ZERFYAlgBq51znvT+8myTg1wAq51zjvW8L+E3gV1hLsuvxz6sRkRmAW0K0J7l7RR5EnJLelmSTwauIY9JbkLzot1iIEuh0cV1JzjPEOo26F9eZpLo6KBG5A5jmBh2lEF2N2jSJVP9+NfrzsHe1tgbQ5PbdCw143X31IV4plH8Y1tKdf7tvb429NaWMWUYsI5aRkgOWkZJDD8tKWiGFYxieAAAAAElFTkSuQmCC"

/***/ }),

/***/ "TIua":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACA0lEQVRYR91XQVLCQBCcERe8WOLNg1hw0eTkF3gCvkB8gfIC9QXCC8Qf8AT9AZ7Ak1aiVR6jnswKbW2sSAJBJsECyz2Snp1Oz6RnYFry4SXnp79LoLe9WmVeOSamWkSlBwI60LplP9NDVL3eFpVZKYOvE3Hx6xk8BnWGwJX9+HGdpPaEAvdFKvrr6gLM9enlgQdQw3Z122D6O+qEiE5HiRMigabl6sb4kwkC/ZLqEvO+pDcAHBkcM19K8Ay091wdxIQnRqC/rZq0wseSy7JiQHRuO/7ZBIGghvn8fdaL5XHwCq+6UvHIC9QLAxfx9iOSaFiObsYJpKi9/G2TkQBubFdX4wR28pj3Ynk8PMvRm0skQGQ5flD+UQ8sVoEXy9GBWY0ILL0HFuABP34Fi/MBIvh+JZwlMSfslVSbmQ/l3ZweCTOYXP09Z+IEAjdUXSLeSH+1JAIvhVddDl0w1oRheK+k6tLhIkkZGzwYHOy5g87UYRQh8fulGKJlPWoztmMncSMyO8H7urqWjuVZSkStV0TAgH6NBHBbeNPVaN1nliAEzE1iRvLEJhyXKDMJQXIRgUzlECYXE0hDwhjN2ps+mVZzcRNO6+yf3HLc5WZ9HakUiF72tYbzRfQ3syGHa7okcYjJ/M/orpSrDTkX7HW5AWq7T7qbJvHcBLIkS4rJrMC/IfAJqiXnIa4hQSQAAAAASUVORK5CYII="

/***/ }),

/***/ "TM+h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function adapt(designWidth, rem2px){
	var d = window.document.createElement('div');
	d.style.width = "1rem";
	d.style.display = "none";
	var head = window.document.getElementsByTagName('head')[0];
	head.appendChild(d);
	var defaultFontSize = parseFloat(window.getComputedStyle(d,null).getPropertyValue('width'));
	var st = document.createElement('style');
	var portrait = "@media screen and (min-width:" + window.innerWidth + "px){html{font-size:" + ((window.innerWidth/(designWidth/rem2px)/defaultFontSize)*100) + "%;}}";
	var landscape = "@media screen and (min-width: " + window.innerHeight + "px){html{font-size:" + ((window.innerHeight/(designWidth/rem2px)/defaultFontSize)*100) + "%;}}"
	st.innerHTML = portrait + landscape;
	head.appendChild(st);
  	return defaultFontSize
}
var defaultFontSize = adapt(640, 100);
		
/* harmony default export */ __webpack_exports__["a"] = ({
	defaultFontSize: defaultFontSize,
	adapt: adapt
});


/***/ }),

/***/ "TW3k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("UFcW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("u28b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__content__ = __webpack_require__("ZPdz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__saveArticle__ = __webpack_require__("jIJk");


// import Hello from '@/components/Hello'


// const Savee = resolve => require(['~/saveArticle'], resolve)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Content',
    component: __WEBPACK_IMPORTED_MODULE_2__content__["a" /* default */]
  }, {
    path: '/save',
    name: 'Save',
    component: __WEBPACK_IMPORTED_MODULE_3__saveArticle__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZPdz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_content_vue__ = __webpack_require__("0i8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_84d8c60e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_content_vue__ = __webpack_require__("Punr");
function injectStyle (ssrContext) {
  __webpack_require__("+eK2")
}
var normalizeComponent = __webpack_require__("J0+h")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84d8c60e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_84d8c60e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_content_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h8+N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_rem__ = __webpack_require__("TM+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_storage__ = __webpack_require__("1Tvo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__leftMenu__ = __webpack_require__("Oj91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rightMenu__ = __webpack_require__("AkOF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setting__ = __webpack_require__("xXdY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__saveArticle__ = __webpack_require__("jIJk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("Gwb+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// vuex

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__static_rem__["a" /* default */].defaultFontSize;
    if (__WEBPACK_IMPORTED_MODULE_2__static_storage__["a" /* default */].get('articles')) {
      if (__WEBPACK_IMPORTED_MODULE_2__static_storage__["a" /* default */].get('articles').length > 0) {
        this.saveTotal = __WEBPACK_IMPORTED_MODULE_2__static_storage__["a" /* default */].get('articles');
      }
    }
    this.wWidth = window.innerWidth;
    // this.$ajax({
    //   methods: 'get',
    //   baseURL: '/api',
    //   url: 'album',
    //   responseType: 'json'
    // }).then((res) => {
    //   console.log(res)
    // }).catch((err) => {
    //   console.log(err)
    // })
  },
  mounted: function mounted() {
    this.getArticle();
  },
  data: function data() {
    return {
      article: '',
      leftmenu: false,
      rightmenu: false,
      night: false,
      setting: false,
      Ibg: '#fafafa',
      saveTotal: [],
      showS: false,
      isSC: false,
      issc: true,
      wWidth: '',
      touchPoint: {}
    };
  },

  components: {
    leftMenu: __WEBPACK_IMPORTED_MODULE_3__leftMenu__["a" /* default */],
    rightMenu: __WEBPACK_IMPORTED_MODULE_4__rightMenu__["a" /* default */],
    setting: __WEBPACK_IMPORTED_MODULE_5__setting__["a" /* default */],
    saveArticle: __WEBPACK_IMPORTED_MODULE_6__saveArticle__["a" /* default */]
  },
  methods: {
    ttt: function ttt(xx) {
      this.$store.commit({
        type: 'changeSave',
        xx: xx
      });
      this.$store.dispatch('changeSave');
    },

    // 手指滑动
    ts: function ts(e) {
      var point = e.targetTouches[0].clientX;
      this.touchPoint.startX = point;
    },
    tm: function tm(e) {
      // e.preventDefault()
      var point = e.targetTouches[0];
      this.touchPoint.stopX = point.clientX;
      if (this.leftmenu || this.rightmenu) {
        e.preventDefault();
      }
    },
    te: function te(e) {
      // e.preventDefault()
      var distand = this.touchPoint.stopX - this.touchPoint.startX;
      if (distand > 20 && !this.leftmenu) {
        if (this.touchPoint.startX <= this.wWidth / 4 && !this.rightmenu) {
          this.leftMenus();
        }
        this.rightmenu = false;
      } else if (distand < -20) {
        if (this.leftmenu) {
          this.leftMenus();
        } else {
          if (this.touchPoint.startX >= this.wWidth * 3 / 4 && !this.leftmenu) {
            this.rightMenus();
          }
        }
      }
      this.touchPoint = {};
    },

    // 左右菜单栏
    leftMenus: function leftMenus() {
      this.leftmenu = !this.leftmenu;
      this.setting = false;
      if (this.leftmenu) {
        document.body.style.overflow = 'hidden';
      } else {
        setTimeout(function () {
          document.body.style.overflow = 'auto';
        }, 300);
      }
    },
    rightMenus: function rightMenus() {
      this.rightmenu = !this.rightmenu;
      this.setting = false;
      document.body.style.overflow = 'hidden';
    },
    hideMenu: function hideMenu() {
      if (this.rightmenu || this.leftmenu || this.setting) {
        this.leftmenu = false;
        this.rightmenu = false;
        this.setting = false;
      }
      document.body.style.overflow = 'auto';
    },
    showSave: function showSave(val) {
      if (val !== '') {
        document.body.style.overflow = 'auto';
      }
      this.leftmenu = false;
      this.showS = !this.showS;
    },
    hideRight: function hideRight() {
      this.rightmenu = false;
    },

    // 可否滑动
    // 获取文章
    getArticle: function getArticle() {
      var _this = this;

      this.rightmenu = false;
      this.$ajax({
        methods: 'get',
        // baseURL: '/article',
        // url: 'today',
        url: 'https://interface.meiriyiwen.com/article/today',
        params: {
          dev: 1
        }
      }).then(function (res) {
        _this.article = res.data.data;
      });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    NPArticle: function NPArticle(data) {
      var _this2 = this;

      this.rightmenu = false;
      if (data > new Date().Format('yyyyMMdd')) {
        alert('已是最后一天，请浏览之前的文章');
        return;
      }
      document.body.style.overflow = 'auto';
      this.showS = false;
      this.$ajax({
        methods: 'get',
        // baseURL: '/article',
        // url: 'day',
        url: 'https://interface.meiriyiwen.com/article/day',
        params: {
          dev: 1,
          date: data
        }
      }).then(function (res) {
        _this2.article = res.data.data;
      });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    randomArticle: function randomArticle() {
      var _this3 = this;

      this.rightmenu = false;
      this.$ajax({
        methods: 'get',
        // baseURL: '/article',
        // url: random',
        url: 'https://interface.meiriyiwen.com/article/random',
        params: {
          dev: 1
        }
      }).then(function (res) {
        _this3.article = res.data.data;
      });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    Save: function Save(data) {
      var _this4 = this;

      this.isSC = true;
      this.issc = true;
      setTimeout(function () {
        _this4.isSC = false;
      }, 500);
      this.rightmenu = false;
      this.saveTotal.unshift(data);
      __WEBPACK_IMPORTED_MODULE_2__static_storage__["a" /* default */].set('articles', this.saveTotal);
    },
    removeSave: function removeSave(data) {
      var _this5 = this;

      this.isSC = true;
      this.issc = false;
      setTimeout(function () {
        _this5.isSC = false;
      }, 500);
      this.rightmenu = false;
      for (var item in this.saveTotal) {
        if (this.saveTotal[item].title === data) {
          this.saveTotal.splice(item, 1);
        }
      }
      __WEBPACK_IMPORTED_MODULE_2__static_storage__["a" /* default */].set('articles', this.saveTotal);
    },

    // 阅读设置
    Setting: function Setting() {
      document.body.style.overflow = 'auto';
      this.setting = true;
      this.leftmenu = false;
    },
    setSize: function setSize(val) {
      document.querySelector('.content').style.fontSize = val;
    },
    setBg: function setBg(val) {
      this.night = false;
      this.Ibg = val;
    },
    setNight: function setNight() {
      this.night = !this.night;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isSaved: function isSaved() {
      for (var item in this.saveTotal) {
        if (this.saveTotal[item].title === this.article.title) {
          return true;
        }
      }
      return false;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapState */])({
    // aa: (state) => state.aa
    aa: 'aa',
    articleSave: 'articleSave'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['toUp']))
});

/***/ }),

/***/ "hiM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['saveArticles'],
  data: function data() {
    return {
      Articles: []
    };
  },

  methods: {
    goArticle: function goArticle(data) {
      this.$emit('go', data);
    },
    hideCur: function hideCur() {
      this.$emit('hide', 1);
    }
  }
});

/***/ }),

/***/ "iFoD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAB2ElEQVRYR+1X3VHDMAyWnQEoG5QJOJ88QEcoE0AnaDsBMAHtBJQNOgK8x+cyAYxQBkjMKWen+W3t/iQ8oKdeI1lfPn2WFAY9G+s5P/xdAFrrUZIkU8bYuMDSNwCsOedLIQT9zk1rPUzTdAoADwAwsA+21v9NCPHexHaNAa31IE3TF3tQW4Xo4DkirshBKTUDgMdC4qa4BSLOqw9qAJRSGwC49dTGxPq9evqvENHFZCElAEqpBQAQjZe0Z0R8cglyALaGX5fM7HTBOb8RQlAZdwx09Pbu/Ug/xHYJQEjtTyXqAxFHVQDm1FMD4reIeN0nAEDETH+5CJVSnTFgjPmRUmbNqgigdw100QPab0GHfQBsH8hmSakTxnG8YozdB6g52NUY8yalpIFVb8XEQpIkG8bYVfDJHgEkviiKhq4L1higP5RShM53uHik3bkYY+6klOtiUONCcqFSLBGRxnbJGgHYnYAWCN+xfIiJvPV6ASCnM4L45JyPinU/WALncAYQe5M3irBK0QkgDib3AnBkObySewMIAUGNJoqiWVvNvUXYJut9V7Ta5Q5djSAGiofZNZxW96JN3Jruk9j5HP1lFMfxmDGW7XWc87EQgsZ5sB0NIDhTS8A/gF8/eM4hXKt9twAAAABJRU5ErkJggg=="

/***/ }),

/***/ "jIJk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_saveArticle_vue__ = __webpack_require__("hiM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_79e64139_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_saveArticle_vue__ = __webpack_require__("K39l");
function injectStyle (ssrContext) {
  __webpack_require__("HwfQ")
}
var normalizeComponent = __webpack_require__("J0+h")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79e64139"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_saveArticle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_79e64139_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_saveArticle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "liws":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABgklEQVRYR+2X33HDIAzGZbFIR6gP3rtCR2g2SDZwNrA3SDfIBnUG4Eg3SDdIFrB6cnGP+B/gXkoewqvh48cnIeEMEo8s8f7wALgPB4wxT5wLeZ6fYnLCGPMMAKc8z88x69y5rQNa6xoAXgBgh4ibUEGtNQHAmYgKpVS1BKIPwBrBghag3ZeIjkIIhufDBI8xgG7xCRFXc4IuQLeIiPYWJCiccwDdyWohBIMMBMcALAjnRImIlS+cXgDHSxbcuoIzAL8uEtFGKbWfikkMwCA/AgBcFzk/jn2QWICrhGua5iM4234mDlxcBBC5aX/61S1LAeC6uEoGYGtHnRQAAA4pAQ6I+PrvAER0ybJsLaXccRiWAnwi4nrBNdwiYukWsygAS19IKUvbRbkbhgy2+22snMcAVIhYRJbiL7vxZIcMAZiknyrF1qlSSln47JkD8NJPtON3IQQ7tawd9+M8d4IeQJuYf32QDOLsA4gBHtNqQ5D8UepLlFt+v4//glue0Kf9cOAbM6UMlAkjciwAAAAASUVORK5CYII="

/***/ }),

/***/ "nNSp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABxElEQVRYR+2WwXHCMBBFd2kgdBA6CB445BY6CB0kHYQOAhVAB5AOKCMHNGohjUjKfGblUUCWZMPgHPDV0urt3+8vM/X8cM/n0x3grkBvCmitR9baz4sBUMgYM55Op/vSL0optSSiDyIadgbQWg/RAREtiGg1mUxQNPkcDoc5M6+JaOQXdgJQSuFQHD6UQkkArfXYGLNm5tkpYSsArfXMWrsNO0gBiEro+L1JmiIAmTM6mDcUOlMgolJ0axJAOoBZcvOtARIqtQNQSkE2yOfnnDLYajAY7Iwx29icUxvPFEAHYphxztXB+28iem6xvl5aA/hgSBmmywG5PRzMGZ9Widy5mq3es7gVs+7lOY4AQWGt3RDRy60p/phQohIgj7cCieYALgvn3IKZH0pAmPnLOYd8b61gYxDBnMaYDTO/FUAcgwjZ4ZzDniJw1M1GsSQbkjDVXZiEuCX9ZZVlzwL4CpKMAIn54+wukPsDary2SsLUYsmMRcQfjdexKAhjP8VqFysQbo50l/0hQd4455an/ugE4GGC7vYlf0SioP8dO5a5CCAAGVVV9ZN1nCyQe2cHY18FoPTg03VQsFeAq42gqwL/AuAXg8PnMr1D8aUAAAAASUVORK5CYII="

/***/ }),

/***/ "omiU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uRnU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAB9klEQVRYR+2W3XHCMAzHJXmBblC6QXzKAHSC0gkKE8AIHYFOABuUDQrv9pkNSjfIArF7ygUufCTOQVJe6sdEZ/0kS38J4c4H7+wfegEwxoyUUjut9TYWYC8A1tpxCGGulBrGIHoBkKitte8AMCWi5yaI3gAEwhizRMSXJoheAdpA1AI45wbe+2kIYYiISayYWvzPiOhJa51VbS8CWGvn8n4AsAGAJRHtWji4aJLn+RgR3wBgwszLU6MzAHk3AJA2Gmmt19c6LgtxDACLOudicwQglRtCmCmlEq311VG3dX4E4Jx78N5/E9HrrZGLECHiZ1Pk+8weMmCtnQHAmJlvLrjyruzSm4tj55wIVPG8VQD5sGZmEZDejjj33n8xc+G7CrAlotmt6Y+RNwGEUrFuqvx/gJYZWDLz4KgGjDFZF+ITAyg7ZMTMw1MdkA/bU60uB4r0ddJFh1hrZUmRDIjcxzciWS5ichqLev9/3wHlUCqUtnEcd+y8UFoA+KhmshagY+ciPosQwiZNU8no4VwEcM4lolYAsELEsxHaNuXee6l0qZ9RGbnI/dGp2wfkfR7bOmqw+5EgiGheN11rM5Dn+VomGjNPOgCpvaJpJUv+AqKxC6QW+oaIbsUViHkXQtSqCE+NSohBmqarrushmoGuHV6VgT4hfgGP0xww4ejTZgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "xXdY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_setting_vue__ = __webpack_require__("97eQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_65069960_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_setting_vue__ = __webpack_require__("JGBW");
function injectStyle (ssrContext) {
  __webpack_require__("TW3k")
}
var normalizeComponent = __webpack_require__("J0+h")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65069960"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_script_index_0_setting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_0_4_vue_loader_lib_template_compiler_index_id_data_v_65069960_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_13_0_4_vue_loader_lib_selector_type_template_index_0_setting_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xffy":
/***/ (function(module, exports) {

//时间
Date.prototype.Format = function (fmt) { //author: jzq
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

/***/ }),

/***/ "zH1Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['article', 'save'],
  data: function data() {
    return {
      saved: this.save,
      now: ''
    };
  },

  watch: {
    save: function save() {
      this.saved = this.save;
    },
    article: function article() {
      this.now = this.article.date.curr;
    }
  },
  // updated () {
  //   this.now = this.article.date.curr || new Date().Format('yyyyMMdd')
  // },
  computed: {
    isToday: function isToday() {
      console.log(1);
      return this.now < new Date().Format('yyyyMMdd');
    }
  },
  methods: {
    Save: function Save() {
      this.saved = !this.saved;
      if (this.saved) {
        var saveArticle = {};
        saveArticle.title = this.article.title;
        saveArticle.author = this.article.author;
        saveArticle.date = this.article.date.curr;
        this.$emit('Save', saveArticle);
      } else {
        this.$emit('removeSave', this.article.title);
      }
    },
    goPrev: function goPrev() {
      this.$emit('article', this.article.date.prev);
    },
    goRandom: function goRandom() {
      this.$emit('random');
    },
    goNext: function goNext() {
      this.$emit('article', this.article.date.next);
    },
    getToday: function getToday() {
      this.$emit('today', this.article.date.curr);
    },
    hideRight: function hideRight() {
      this.$emit('hidee', false);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a74ddab3d1b1887fdf4e.js